document.addEventListener('DOMContentLoaded', () => {
  const stickyButton = document.querySelector('.sticky-add-to-cart .button');
  if (stickyButton) {
    stickyButton.addEventListener('click', (event) => {
      const formSubmit = document.querySelector('.product-form__submit');
      if (formSubmit) formSubmit.click();
    });
  }

  const triggerElement = document.querySelector('.product-form__submit');
  const isMobile = window.matchMedia('(max-width: 750px)').matches;
  const mediaElement = isMobile ? document.querySelector('.grid__item.product__media-wrapper') : null;
  let isMediaInView = false;
  let isTriggerInView = true;
  const targetElement = document.querySelector('.sticky-add-to-cart');
  const visibilityClass = 'is-visible';

  const scrollToTopWrapper = document.querySelector('.scroll-to-top-wrapper');
  const gorgiasChat = document.getElementById('gorgias-chat-container');

  let currentGorgiasChat = gorgiasChat;
  let isFooterVisible = false;

  const observer = new MutationObserver(() => {
    const injectedChat = document.getElementById('gorgias-chat-container');
    if (injectedChat !== currentGorgiasChat) {
      currentGorgiasChat = injectedChat;
      checkPositionAndUpdateVisibility();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  const stickyObserver = new MutationObserver(() => {
    const sticky = document.querySelector('.sticky-add-to-cart');
    if (sticky?.classList.contains('is-visible')) {
      adjustElementsForSticky(true);
    }
  });

  stickyObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  const footerElement = document.querySelector('footer');

  if (footerElement) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        isFooterVisible = entry.isIntersecting;
        if (isFooterVisible) {
          targetElement.classList.remove(visibilityClass);
          adjustElementsForSticky(false);
        } else {
          checkPositionAndUpdateVisibility();
        }
      },
      {
        root: null,
        threshold: 0.5,
      }
    );

    footerObserver.observe(footerElement);
  }

  if (!triggerElement || !targetElement) {
    console.warn('Missing element for Sticky Add To Cart');
    return;
  }

  let isThrottled = false;
  const throttleDelay = 100;

  // Intersection Observer for trigger (add-to-cart) and media (mobile)
  const triggerObserver = new IntersectionObserver(
    ([entry]) => {
      isTriggerInView = entry.isIntersecting;
      updateStickyVisibility();
    },
    {
      root: null,
      threshold: 0,
    }
  );
  triggerObserver.observe(triggerElement);

  if (isMobile && mediaElement) {
    const mediaObserver = new IntersectionObserver(
      ([entry]) => {
        isMediaInView = entry.isIntersecting;
        updateStickyVisibility();
      },
      {
        root: null,
        threshold: 0,
      }
    );
    mediaObserver.observe(mediaElement);
  }

  function checkPositionAndUpdateVisibility() {
    updateStickyVisibility();
  }

  function updateStickyVisibility() {
    const shouldShow = !isTriggerInView && !isFooterVisible && !(isMobile && isMediaInView);

    if (shouldShow) {
      targetElement.classList.add(visibilityClass);
      adjustElementsForSticky(true);
    } else {
      targetElement.classList.remove(visibilityClass);
      adjustElementsForSticky(false);
    }
  }

  function throttledScrollHandler() {
    if (!isThrottled) {
      updateStickyVisibility();
      isThrottled = true;
      setTimeout(() => {
        isThrottled = false;
      }, throttleDelay);
    }
  }

  updateStickyVisibility();

  function adjustElementsForSticky(isVisible) {
    const desktopOffset = '7rem';
    const mobileOffset = '4.5rem';
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const offset = isDesktop ? desktopOffset : mobileOffset;

    // Push scroll to top
    if (scrollToTopWrapper) {
      scrollToTopWrapper.style.transition = 'transform 0.3s ease';
      scrollToTopWrapper.style.transform = isVisible ? `translateY(-${offset})` : 'translateY(0)';
    }

    // Push Gorgias iframe manually
    const gorgiasIframe = document.querySelector('#gorgias-chat-container iframe#chat-button');
    if (gorgiasIframe) {
      gorgiasIframe.style.transition = 'bottom 0.3s ease';
      gorgiasIframe.style.bottom = isVisible ? offset : '20px'; // Fallback to their default
    }
  }

  window.addEventListener('scroll', throttledScrollHandler);
  window.addEventListener('resize', throttledScrollHandler);
});
